/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WeightLossAggregateDto { 
    /**
     * The aggregate identifier.
     */
    id: string;
    /**
     * The aggregate status.
     */
    status: WeightLossAggregateDto.StatusEnum;
    /**
     * The type of aggregate.
     */
    type: WeightLossAggregateDto.TypeEnum;
    /**
     * The month associated with the aggregate. 1 - January, 2 - February...
     */
    monthIndex: number;
    /**
     * The year associated with the aggregate.
     */
    year: number;
    /**
     * The check-in identifier.
     */
    checkInId?: string;
    /**
     * The subscription identifier.
     */
    subscriptionId?: string;
    /**
     * The (payment) order identifier.
     */
    orderId?: string;
    /**
     * The medication order identifier.
     */
    medicationOrderId?: string;
    /**
     * The refill appointment identifier.
     */
    appointmentId?: string;
    /**
     * The refill appointment URL.
     */
    refillAppointmentUrl?: string;
}
export namespace WeightLossAggregateDto {
    export type StatusEnum = 'PENDING' | 'COMPLETED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Completed: 'COMPLETED' as StatusEnum
    };
    export type TypeEnum = 'INITIAL' | 'CHECK_IN';
    export const TypeEnum = {
        Initial: 'INITIAL' as TypeEnum,
        CheckIn: 'CHECK_IN' as TypeEnum
    };
}


